import api from "@/api/url";

export default {
    namespaced: true,
    
    state: () => {
        return {
            integrations: [],
            calendars: {
                "google calendar": {
                    "id": "",
                    "timeZone": "",
                    "summary": "",
                },
            },
        };
    },

    getters: {
        integrations: (state) => state.integrations,
        calendars: (state) => state.calendars,
    },

    mutations: {
        set(state, [key, value]) {
            state[key] = value;
        },
    },
    
    actions: {
        fetchUserIntegrations({ commit, state }, { params, refresh }) {
            if (!refresh && state.integrations.length) return;

            return api.integration.getAll(params)
                .then((resp) => {
                    const data = resp?.data?.data;                       
                    commit("set", ["integrations", data.data]);
                });
        },

        initiateIntegration(_, payload) {
            return api.integration.initiate(payload)
                .then((resp) => {                    
                    return resp.data.data;
                });
        },

        enableIntegration(_, payload) {
            return api.integration.enable(payload)
                .then((resp) => {
                });
        },

        disableIntegration({ state, commit }, id) {
            return api.integration.disable(id)
                .then((resp) => {
                    const integrations = state.integrations;
                    const updatedIntegrations = integrations.filter(item => item._id !== id);

                    commit("set", ["integrations", updatedIntegrations]);
                });
        },

        getPrimaryCalendar({ state, commit }, providerKey) {
            return api.calendar.getPrimaryCalendar({ providerKey })
                .then((resp) => {
                    const data = resp.data.data;                    
                    commit("set", ["calendars", {
                        ...state.calendars,
                        [providerKey]: {
                            id: data?.id,
                            summary: data?.summary,
                            timeZone: data?.timeZone,
                        },
                    }]);
                    return data;
                });
        },
    },
};